"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logPropError = exports["default"] = exports.BASE_URL = void 0;
var _has = _interopRequireDefault(require("lodash/fp/has"));
var BASE_URL = 'https://uikit.developers.rio.cloud/';

// Logs prop errors.
exports.BASE_URL = BASE_URL;
var logPropError = function logPropError() {
  var errorProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 ? arguments[1] : undefined;
  var componentName = arguments.length > 2 ? arguments[2] : undefined;
  var removeVersion = arguments.length > 3 ? arguments[3] : undefined;
  var additionalText = arguments.length > 4 ? arguments[4] : undefined;
  errorProps.forEach(function (errorProp) {
    // Check whether the deprected prop is used by checking the component props
    if ((0, _has["default"])(errorProp.prop, props)) {
      /* eslint-disable no-console */
      console.error(['RIO UIKIT: ', errorProp.propCaption ? errorProp.propCaption : 'Prop ', "\"".concat(errorProp.prop, "\""), componentName ? " of \"".concat(componentName, "\"") : '', " has been removed", removeVersion ? " in v".concat(removeVersion) : '', errorProp.replacement ? ". Please use \"".concat(errorProp.replacement, "\" instead") : '', errorProp.url ? " as documented in ".concat(BASE_URL).concat(errorProp.url, ". ") : '.', additionalText ? " ".concat(additionalText) : ''].join(''));
    }
  });
};
exports.logPropError = logPropError;
var _default = logPropError;
exports["default"] = _default;